module.exports = __webpack_public_path__ + "static/media/dinning-experience.a9ff0570.png";